import axios from 'axios';
import { SingleApiResponse } from '@ianesthesie-kit/services';
import { GenerateSessionResponse } from './terra.model';

export class TerraService {
  private static readonly INSTANCE = new TerraService();

  private baseUrl = '/terra';

  private constructor() {
    //
  }

  public static getInstance() {
    return this.INSTANCE;
  }

  public generateSession(): Promise<GenerateSessionResponse> {
    const currentUrl = this.getNormalizedCurrentUrl();

    const url = `${this.url(
      '/widget-session'
    )}?return-url-success=${currentUrl}&return-url-failure=${currentUrl}`;
    return axios
      .post<SingleApiResponse<GenerateSessionResponse>>(url)
      .then((resp) => resp.data.data);
  }

  public isEligibleToConnect(): Promise<boolean> {
    return axios
      .get<SingleApiResponse<boolean>>(this.url('/eligibility'))
      .then((resp) => resp.data.data);
  }

  public isIntegrated(): Promise<boolean> {
    return axios
      .get<SingleApiResponse<boolean>>(this.url('/user/exists'))
      .then((resp) => resp.data.data);
  }

  public unregister(): Promise<void> {
    return axios.delete(this.url('/user'));
  }

  private url(segment: string): string {
    if (!segment) {
      return this.baseUrl;
    }
    return `${this.baseUrl}${segment}`;
  }

  private getNormalizedCurrentUrl() {
    let currentUrl = typeof location !== 'undefined' ? location.href : '';
    const hasQuery = currentUrl.includes('?');
    if (hasQuery) {
      currentUrl = this.removeTerraCallbackParams(currentUrl);
    }

    if (currentUrl.endsWith('?')) {
      currentUrl = currentUrl.slice(0, currentUrl.length - 1);
    }

    return currentUrl;
  }

  private removeTerraCallbackParams(currentUrl: string) {
    return ['lan', 'reason', 'user_id', 'resource', 'reference_id'].reduce(
      (acc, param) => {
        if (!currentUrl.includes(param)) {
          return acc;
        }
        // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(`${param}=.+?(&|$)`);
        return acc.replace(regex, '');
      },
      currentUrl
    );
  }
}
